import React, { useEffect, useState } from 'react';
import styles from './Dashboard.module.css';
import apiService from '../api/apiService';
import { MoreVerticalIcon } from 'lucide-react';

export const RoomOverview = ({ hotelId }) => {
  const [roomsData, setRoomsData] = useState([]);

  useEffect(() => {
    const fetchRoomsAndPrices = async () => {
      try {
        const roomsResponse = await apiService.get(`/rooms/?hotel=${hotelId}`);
        const pricesResponse = await apiService.get(
          `/room-prices/?hotel=${hotelId}`
        );

        const rooms = roomsResponse;
        const prices = pricesResponse;

        // Match rooms with prices
        const updatedRoomsData = rooms
          .filter(room => room.room_type.name !== 'FOC')
          .map(room => {
            const roomPrice = prices.find(price => price.room === room.id);
            return {
              type: room.room_type.name,
              available: room.status === 'available' ? 1 : 0,
              total: 1,
              price: roomPrice ? roomPrice.amount : 'N/A',
            };
          });

        // Deduplicate by room type (keep only first occurrence)
        const uniqueRoomTypes = updatedRoomsData.reduce((acc, current) => {
          if (!acc.some(room => room.type === current.type)) {
            acc.push(current);
          }
          return acc;
        }, []);

        setRoomsData(uniqueRoomTypes);
      } catch (error) {
        console.error('Error fetching room data:', error);
      }
    };

    fetchRoomsAndPrices();
  }, []);

  return (
    <section className={styles.roomOverview} aria-label="Room Overview">
      <h2 className={styles.sectionTitle}>Room Rates</h2>
      <div className={styles.roomGrid}>
        {roomsData.map((room, index) => (
          <div key={index} className={styles.roomCard}>
            <div className={styles.roomType}>
              {room.type.charAt(0).toUpperCase() + room.type.slice(1)}
            </div>
            <div className={styles.roomPriceContainer}>
              <div className={styles.priceAmount}>&#8377;{room.price}</div>
              <div className={styles.priceUnit}>/ day</div>
            </div>
            {/* <div className={styles.roomCardHeader}>
              {room.deals && (
                <div className={styles.dealsBadge}>{room.deals} Deals</div>
              )}
              <MoreVerticalIcon />
            </div>
            <div className={styles.roomAvailability}>
              {room.available}/{room.total}
            </div> */}
          </div>
        ))}
      </div>
    </section>
  );
};
